import { PerformanceClient } from "@agoda/performance-client";
import { getAgoda } from "libs/analytics/functions/agoda.homes";
import { messagingClient } from "libs/analytics/functions/messagingClient";
import { getPageTypeId } from "libs/analytics/mappers/pageTypeIdMapper";
import type { Path } from "router";
import { getDevicePlatform } from "./devicePlatformService";

type AddPerformanceInsightInput = {
    userId: string;
    memberId: number;
    pathname: Path;
};

export const sendPerformanceMetric = async (options: Pick<AddPerformanceInsightInput, "pathname">) => {
    const agoda = getAgoda();
    const tags = { appName: "property-onboarding-clientside" };

    const performanceClient = new PerformanceClient(messagingClient, {
        ...options,
        userId: agoda.userId,
        memberId: agoda.memberId,
        trafficGroupId: 0,
        aid: 0,
        cid: 0,
        pageTypeId: getPageTypeId(options.pathname),
        languageId: 0,
        origin: "",
        devicePlatformId: getDevicePlatform(),
        whiteLabelId: 1,
        clientId: 0,
    });

    try {
        // Measure ALCP
        const alcpPromise = performanceClient.measureAgodaLcp(tags).await(); // LCP
        performanceClient.measureCumulativeLayoutShift(tags); // CLS

        // Wait for ALCP to complete
        await alcpPromise;

        // Measure TTI
        const interactivePromise = performanceClient.measureInteractive(Promise.resolve(), tags).await();
        performanceClient.measureTotalBlockingTime(interactivePromise, tags); // TBT

        // Measure other metrics
        performanceClient.measureInteractionToNextPaint(tags); // INP
        performanceClient.measureInputFirstDelay(tags); // IFD
        performanceClient.measureTimeToFirstByte(tags); // TTFB
    } catch (error) {
        console.error("Error sending performance metrics:", error);
    }
};
